import { Observable, combineLatest, mergeMap, of, take } from 'rxjs';
import cloneDeep from 'lodash.clonedeep';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DprDetails } from '@shared/models/dpr';
import { OfflineFacade, UserDetailsFacade } from '@shared/state/facades';
import { Injectable } from '@angular/core';

@UntilDestroy()
@Injectable()
export class DprProgressWithoutTargetOfflineService {
  constructor(
    private userDetailsFacade: UserDetailsFacade,
    private offlineFacade: OfflineFacade
  ) {}

  updateDependentProgressWithoutTargetPrevValues(
    startDate: Date
  ): Observable<boolean> {
    return combineLatest([
      this.userDetailsFacade.query.projectSetup$,
      this.offlineFacade.query.combinedDprDetailsList$,
    ]).pipe(
      untilDestroyed(this),
      take(1),
      mergeMap(([projectSetup, dprDetailsList]) => {
        const progressWithoutTargetList =
          projectSetup?.progressWithoutTarget?.progressWithoutTargetItems ?? [];
        const dprDetailsCopy = cloneDeep(dprDetailsList) as DprDetails[];

        progressWithoutTargetList.forEach((progressWithoutTarget) => {
          const items = dprDetailsCopy
            .filter((x) => new Date(x.dprDateTime) >= new Date(startDate))
            .sort((a, b) => {
              return (
                new Date(a.dprDateTime).valueOf() -
                new Date(b.dprDateTime).valueOf()
              );
            });
          for (let i = 1; i < items.length; i++) {
            const prevItem = (
              items[i - 1].dprProgressWithoutTarget
                .dprProgressWithoutTargetDetails || []
            ).find(
              (x) => x.progressWithoutTargetId === progressWithoutTarget.id
            );
            const currentItem = (
              items[i].dprProgressWithoutTarget
                .dprProgressWithoutTargetDetails || []
            ).find(
              (x) => x.progressWithoutTargetId === progressWithoutTarget.id
            );

            if (prevItem && currentItem) {
              currentItem.clearedTotal =
                (prevItem.clearedTotal || 0) + (currentItem.clearedToday || 0);
              this.offlineFacade.setDprDetails(cloneDeep(items[i]));
            }
          }
        });
        return of(true);
      })
    );
  }
}
